module.exports = __webpack_public_path__ + "img/lssyt.a06c3ce7.png";